module.exports = __webpack_public_path__ + "media/images/flags/16/Burundi-7e1540cf4db489f8706a363e539dc2bd.png";